import { type Dispatch, type SetStateAction, useState } from "react";
import { useResetOnOpen } from "web_myplann/Shared/Hooks/useResetOnOpen";

export const useResetStateOnOpen = <T>(open: boolean, initial: T) => {
	const [value, setValue] = useState(initial);

	useResetOnOpen(open, initial, setValue);

	return [value, setValue] as [T, Dispatch<SetStateAction<T>>];
};
